/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import { UsuarioGrupo } from 'Models/cadastros'
import IAcao from 'Models/docas/IAcao'
import IArmazemCota from 'Models/docas/IArmazemCota'
import IFormAgendamentoBiomassa from 'Models/docas/IFormAgendamentoBiomassa'
import IFormArmazemCotaFilter from 'Models/docas/IFormArmazemCotaFilter'
import IFormArmazemCotaInput from 'Models/docas/IFormArmazemCotaInput'
import moment from 'moment'
import ApiService from 'Services/ApiService'
import {
  ServiceListResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'
//import IAcao from 'Views/Docas/Models/IAcao'

const armazemCota = {
  buscaCotas: async (idComponente: number, filtros: IFormArmazemCotaFilter) => {
    const resposta: AxiosResponse<ServiceListResponse<IArmazemCota>> =
      await ApiService({
        idComponente,
      }).get<ServiceListResponse<IAcao>>(
        QueryStringFilter(`${hosts.WS_DOCAS}/ArmazemCota`, filtros),
      )

    return resposta
  },

  atualizaCota: async (idComponente: number, dados: IFormArmazemCotaInput) => {
    const resposta: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/ArmazemCota`, dados)

    return resposta
  },

  criaAgendamentoBiomassa: async (
    idComponente: number,
    data: IFormAgendamentoBiomassa[],
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).post<ServiceUpdateResponse>(
      `${hosts.WS_DOCAS}/AgendamentoBiomassa`,
      data,
    )

    return result
  },

  editaAgendamentoBiomassa: async (
    idComponente: number,
    data: IFormAgendamentoBiomassa[],
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/AgendamentoBiomassa`, data)

    return result
  },
}

export default armazemCota
